module.exports = __webpack_public_path__ + "img/bee1.9cad87c6.jpeg";